import {APIResponse, easasAxios} from "../services/HttpService";
import {AxiosInstance} from 'axios'
import {IUserInfo} from "./apiModels";

const API_SCOPE = "/users";

class UserDataApiDefinition {
    private httpClient: AxiosInstance;

    constructor(axiosInstance?: AxiosInstance) {
        console.log("DatasetDataApi obj created!")
        this.httpClient = axiosInstance ?? easasAxios;
    }

    async getDataInfo(username: string): Promise<APIResponse<IUserInfo>> {
        try {
            const {data} = await this.httpClient.get(`${API_SCOPE}/${username}/info`);
            return {data}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }
}

export const UserDataApi = new UserDataApiDefinition();